/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

const FileCard = ({ file, isDownloading, downloadAttachment, openModal }) => {
  const isVideo =
    ["mp4", "mov", "webm"].includes(file.attachment_type?.toLowerCase()) ||
    ["mp4", "mov", "webm"].includes(
      file.originalFileName?.split(".").pop()?.toLowerCase(),
    );

  return (
    <div
      className="block-files"
      onClick={() => openModal(file)}
      style={{ cursor: "pointer" }}
    >
      {isVideo ? (
        <div
          className="img-fluid rounded border d-flex align-items-center justify-content-center"
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
          }}
        >
          <svg width="35" viewBox="0 0 15.826 11.867">
            <path
              fill="#b8c0c9"
              id="video-camera"
              d="M15.1,129.938a1.31,1.31,0,0,0-1.379.121l-1.208.9a3.3,3.3,0,0,0-3.28-2.967H3.3a3.3,3.3,0,0,0-3.3,3.3v5.274a3.3,3.3,0,0,0,3.3,3.3H9.23a3.3,3.3,0,0,0,3.28-2.967l1.206.9a1.318,1.318,0,0,0,2.11-1.055v-5.618A1.311,1.311,0,0,0,15.1,129.938Zm-3.89,6.622a1.978,1.978,0,0,1-1.978,1.978H3.3a1.978,1.978,0,0,1-1.978-1.978v-5.274A1.978,1.978,0,0,1,3.3,129.308H9.23a1.978,1.978,0,0,1,1.978,1.978Zm3.3.169-1.978-1.474v-2.665l1.978-1.474Z"
              transform="translate(0 -127.99)"
            />
          </svg>
        </div>
      ) : (
        /* ✅ Image preview */
        <img
          src={file.imagePreview || file.url}
          alt={file.originalFileName}
          className="img-fluid rounded border"
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
          }}
        />
      )}

      {isDownloading ? (
        <div className="actions">
          <div className={"downloading-loader "}>
            <div className={"spin"}></div>
          </div>
        </div>
      ) : (
        <div className="actions">
          <button
            className="attached_file_btn"
            onClick={(e) => {
              e.stopPropagation();
              downloadAttachment(file);
            }}
          >
            <svg width="15" viewBox="2 4 20 16">
              <path fill="#ffffff" d="m12 16 4-5h-3V4h-2v7H8z"></path>
              <path
                fill="#ffffff"
                d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
              ></path>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default FileCard;
